import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgPopUpIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M4 26.667A6.667 6.667 0 0 1 10.667 20H18v3.333h-7.333a3.333 3.333 0 0 0-3.334 3.334v26.666a3.333 3.333 0 0 0 3.334 3.334h26.666a3.333 3.333 0 0 0 3.334-3.334V50H44v3.333A6.667 6.667 0 0 1 37.333 60H10.667A6.667 6.667 0 0 1 4 53.333z" />
      <path d="M37.903 27.572h-11.76V24h11.76c.947 0 1.856.376 2.526 1.046l2.525 2.526A3.57 3.57 0 0 1 44 30.098v11.763h-3.571V30.098L22.525 48 20 45.474z" />
      <path d="M56 43c0 3.866-2.985 7-6.667 7H33.778v-3.5h15.555c1.841 0 3.334-1.567 3.334-3.5V15c0-1.933-1.493-3.5-3.334-3.5H22.667c-1.841 0-3.334 1.567-3.334 3.5v17.419H16V15c0-3.866 2.985-7 6.667-7h26.666C53.015 8 56 11.134 56 15z" />
    </g>
  </svg>
)
export default SvgPopUpIcon
